"use client";

import Logo from "@/components/ui/Logo";
import IconComponent from "@/helpers/functions/getIcon";
import { useState, useRef, useEffect } from "react";
import Navigation from "./Navigation";

export default function NavigationAside({ options, mainMenu, infoMenu, lang, cdn }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const asideRef = useRef(null);

  const handleMenuClick = () =>{
    setIsMenuOpen(!isMenuOpen);
  } 

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (asideRef.current && !asideRef.current.contains(event.target)) {
        setIsMenuOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMenuOpen]);

  const asideClass = `fixed   flex flex-col justify-between shadow-lg  bg-card-foreground lg:bg-white/0 lg:shadow-none py-6  top-0 duration-200 z-50 h-full w-full max-w-[20rem] lg:max-w-[16rem] bg-gray-800 text-white px-6 lg:pl-6 lg:pr-0 ${isMenuOpen ? "left-0" : "lg:left-0 -left-[20rem]"}`;

  return (
    <>
      <div
        className={`fixed  w-full h-full z-40 bg-dark lg:hidden  duration-200 ${isMenuOpen ? "opacity-100 block" : "opacity-0 hidden"}`}
      ></div>
      <div className="fixed shadow-lg lg:hidden px-4 items-center flex justify-between just lg:px-8 py-4 bg-card-foreground w-full z-30">
        <Logo onClick={handleLinkClick} options={options} cdn={cdn} />
        <button
          onClick={handleMenuClick}
          aria-label="Abrir Menu Mobile"
          className="cursor-pointer bg-card rounded-md p-2.5 hover:scale-[101%] duration-200"
        >
          <IconComponent
            iconName={"Menu"}
          />
        </button>
      </div>
      <aside ref={asideRef} className={asideClass}>
        <Navigation
          options={options}
          infoMenu={infoMenu}
          lang={lang}
          cdn={cdn}
          handleLinkClick={handleLinkClick}
          mainMenu={mainMenu}
        />
      </aside>
    </>
  );
}
